import styled from 'styled-components';
import base from '@sizeid/commons/utils/base';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-left: ${base(-2)};
  width: 600px;

  ${media.lessThan('sm')`
    display: none;
  `};
`;
